export default __webpack_public_path__ + "eafb28b.png";